import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReplay: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="replay, play-again"><path d="M10.25 15.25V8.75L15.25 12L10.25 15.25Z" fill="currentColor"/><path d="M4.13348 8.16128C5.55557 5.253 8.54321 3.25 11.9987 3.25C16.8312 3.25 20.7487 7.16751 20.7487 12C20.7487 16.8325 16.8312 20.75 11.9987 20.75C7.51445 20.75 3.81808 17.3768 3.30859 13.0294" stroke="currentColor" strokeWidth="1.5"/><path d="M3.5 4V8.75H8.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconReplay;
